import { NavDataType } from "./common";
import { PROVIDER_PATHS } from "./paths";

export const PROVIDER_MENU: NavDataType[] = [
  {
    label: "Dashboard",
    path: PROVIDER_PATHS.DASHBOARD,
    value: "dashboard",
  },
  {
    label: "Scheduling",
    value: "scheduling",
    children: [
      {
        label: "Appointments",
        path: PROVIDER_PATHS.APPOINTMENTS,
        value: "appointments",
      },
      {
        label: "Availability",
        path: PROVIDER_PATHS.AVAILABILITY,
        value: "availability",
      },
    ],
  },
  {
    label: "Patients",
    value: "patients",
    path: PROVIDER_PATHS.PATIENT_LIST,
    // children: [
    // {
    //   label: "Patient List",
    //   path: PROVIDER_PATHS.PATIENT_LIST,
    //   value: "patient_list",
    // },
    // {
    //   label: "Patient Flags",
    //   path: PROVIDER_PATHS.PATIENT_FLAGS,
    //   value: "patient_flags",
    // },
    // {
    //   label: "Consent Form",
    //   path: PROVIDER_PATHS.CONSENT_FORM,
    //   value: "consent_form",
    // },
    // ],
  },
  {
    label: "Communications",
    value: "communications",
    path: PROVIDER_PATHS.COMMUNICATION,
    // children: [
    //   {
    //     label: "SMS/Text",
    //     path: PROVIDER_PATHS.MESSAGES,
    //     value: "messages",
    //   },
    //   {
    //     label: "Chat",
    //     path: PROVIDER_PATHS.CHAT,
    //     value: "chat",
    //   },
    //   {
    //     label: "Email",
    //     path: PROVIDER_PATHS.EMAIL,
    //     value: "email",
    //   },
    //   {
    //     label: "Fax",
    //     path: PROVIDER_PATHS.FAX,
    //     value: "fax",
    //   },
    //   {
    //     label: "Contact Dictionary",
    //     path: PROVIDER_PATHS.DICTIONARY,
    //     value: "dictionary",
    //   },
    // ],
  },
  {
    label: "Collaboration",
    value: "collaboration",
    children: [
      {
        label: "Task",
        path: PROVIDER_PATHS.TASKS,
        value: "tasks",
      },
      {
        label: "Referral",
        path: PROVIDER_PATHS.REFERRALS,
        value: "referral",
      },
      // {
      //   label: "Refill Request",
      //   path: PROVIDER_PATHS.REFILL_REQUEST,
      //   value: "refill_request",
      // },
      // {
      //   label: "Results",
      //   path: PROVIDER_PATHS.RESULTS,
      //   value: "results",
      // },
      {
        label: "Open Visits",
        path: PROVIDER_PATHS.OPEN_ENCOUNTERS,
        value: "open_encounters",
      },
      {
        label: "Assessments",
        path: PROVIDER_PATHS.ASSESSMENTS,
        value: "assessments",
      },
      {
        label: "Patient Inquiries",
        path: PROVIDER_PATHS.PATIENT_INQUIRIES,
        value: "patient_inquiries",
      },
    ],
  },
  {
    label: "Billing",
    value: "billing",
    children: [
      {
        label: "Billing",
        path: PROVIDER_PATHS.BILLING,
        value: "billing",
      },
      {
        label: "Payments",
        path: PROVIDER_PATHS.PAYMENTS,
        value: "payments",
      },
      {
        label: "Account Receivable",
        path: PROVIDER_PATHS.ACCOUNT_RECEIVABLE,
        value: "account_receivable",
      },
      {
        label: "Fee Schedule",
        path: PROVIDER_PATHS.FEE_SCHEDULE,
        value: "fee_schedule",
      },
    ],
  },
  {
    label: "Reports",
    path: PROVIDER_PATHS.CLINICAL_REPORTS,
    value: "reports",
  },
  {
    label: "Library",
    value: "library",
    children: [
      {
        label: "Data Import",
        path: PROVIDER_PATHS.LIBRARY,
        value: "dataImport",
      },
      {
        label: "Catalog",
        path: PROVIDER_PATHS.LIBRARY_CATALOG,
        value: "catalog",
      },
      // {
      //   label: "Form Builder",
      //   path: PROVIDER_PATHS.LIBRARY_FORM_BUILDER,
      //   value: "formBuilder",
      // },
      {
        label: "Templates",
        path: PROVIDER_PATHS.LIBRARY_TEMPLATES,
        value: "templates",
      },
      {
        label: "Education Materials",
        path: PROVIDER_PATHS.LIBRARY_EDUCATION_MATERIAL,
        value: "educationMaterials",
      },
      {
        label: "Visit Note Templates",
        path: PROVIDER_PATHS.VISIT_TEMPLATES,
        value: "visit_templates",
      },
    ],
  },
  {
    label: "Settings",
    value: "settings",
    children: [
      {
        label: "Account Settings",
        path: PROVIDER_PATHS.ACCOUNT_SETTINGS,
        value: "account_settings",
      },
      {
        label: "Flag Setting",
        path: PROVIDER_PATHS.FLAG_SETTINGS,
        value: "flag_setting",
      },
      {
        label: "Practice Settings",
        path: PROVIDER_PATHS.PRACTICE_SETTING,
        value: "pratice_setting",
      },
      {
        label: "User Settings",
        path: PROVIDER_PATHS.USER_SETTINGS,
        value: "user_settings",
      },
    ],
  },
];
